import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles';

export default createUseStyles(({ breakpoints }: ITheme) => ({
  root: {
    backgroundColor: 'var(--x-accent-2-1)',
    borderRadius: 50,
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.16)',
    color: '#fff',
    fontWeight: 500,
    marginBottom: 24,
    marginInline: 'auto',
    padding: [10, 24],
    textAlign: 'center',
    width: 'fit-content',
  },
}));
